import React from 'react';
import "./aboutMeText.css";

function AboutMeText() {
  return (
    <p>
    Software developer by day, poet by moonlight (well, maybe not quite moonlight!). I build apps that solve problems, especially those related to mental health. My goal? Code that empowers, a published book someday, and staying balanced – physically, emotionally, and mentally. Flexibility and tenacity keep me going!
    </p>
  );
}

export default AboutMeText;